import filigrane from '@assets/svg/filigrane.svg'
import type { BreadcrumbItem } from '@config'
import { Breadcrumbs } from '@layouts/breadcrumbs/breadcrumbs-deprecated'
import { FaqSearchbar } from '@layouts/faq-searchbar-deprecated'
import { Divider } from '@ui/atoms/Divider'
import { Container } from '@ui/container'
import React, { type FC, type PropsWithChildren } from 'react'

type FaqTemplateProps = {
  breadcrumbs?: BreadcrumbItem[]
  titleComponent?: React.ElementType
}

const FaqTemplate: FC<PropsWithChildren & FaqTemplateProps> = ({
  titleComponent,
  breadcrumbs,
  children,
}) => {
  const Component = titleComponent

  return (
    <>
      <Container className="flex max-w-none justify-center bg-theme-default-accent1 laptop:!max-w-none">
        <Container
          className="max-w-laptopL w-full bg-theme-default-accent1 pb-8 pt-4"
          style={{
            backgroundImage: `url(${filigrane})`,
          }}
        >
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <Container className="mb-8 mt-4 text-center font-medium">
            <Component className="text-200 font-medium">
              Foire aux questions
            </Component>
            <p className="text-085">Toutes les réponses à vos questions</p>
          </Container>

          <FaqSearchbar />
        </Container>
      </Container>

      <Divider key="faq-header-divider" />
      <Container className="my-6">{children}</Container>
    </>
  )
}

export default FaqTemplate
